import { FC } from 'react';
import Link from 'next/link';
import cn from 'classnames';

export interface AmplienceHeadlineProps {
  title?: string;
  url?: string;
  openInANewTab?: boolean;
  hierarchy?: 'H1' | 'H2' | 'H3' | 'H4' | 'H5' | 'H6';
  styledAs?: 'H1' | 'H2' | 'H3' | 'H4' | 'H5' | 'H6';
}

const AmplienceHeadline: FC<AmplienceHeadlineProps> = ({ title, hierarchy = 'H1', styledAs, url, openInANewTab }) => {
  const HeadingTag = hierarchy.toLowerCase() as keyof JSX.IntrinsicElements;
  const visualStyle = styledAs ?? hierarchy;

  const renderTitle = url ? (
    <Link
      className="hover:underline"
      href={url}
      target={openInANewTab ? '_blank' : '_self'}
      rel="noopener noreferrer"
      aria-label={title}
    >
      {title}
    </Link>
  ) : (
    <>{title}</>
  );

  return (
    <div
      data-testid="headline-container"
      className={cn('flex', {
        'justify-center': visualStyle === 'H1' || visualStyle === 'H2' || visualStyle === 'H3',
      })}
    >
      {visualStyle === 'H2' && (
        <div className="headline mr-5 mt-6 h-px grow bg-gold" data-testid="headline-divider-left" />
      )}
      <HeadingTag className={cn(`as-${visualStyle.toLowerCase()}`, 'max-w-[80%]', 'headline')}>
        {renderTitle}
      </HeadingTag>
      {visualStyle === 'H2' && (
        <div className="headline ml-5 mt-6 h-px grow bg-gold" data-testid="headline-divider-right" />
      )}
    </div>
  );
};

export default AmplienceHeadline;
